import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class RichTextWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
    };
  }

  static defaultProps = {
    // value: '',
  };

  static propTypes = {
    // value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  };

  // componentWillReceiveProps(nextProp) {
  //   if (nextProp.value !== this.state.editorState) {
  //     this.setState({
  //       editorState: nextProp.value,
  //     });
  //   }
  // }

  onChange = (value) => {
    this.setState({
      editorState: value,
    }, () => {
      console.log(this.props.onChange);
      // this.props.onChange(value);
    });
  }

  render() {
    return (
      <Editor
        initialEditorState={this.state.editorState}
        onEditorStateChange={this.onChange}
      />
    );
  }
}

// const RichTextWidget = props => (
//   <ReactQuill
//     modules={RichTextWidget.modules}
//     formats={RichTextWidget.formats}
//     theme="snow"
//     value={props.value}
//     onChange={props.onChange}
//   />
// );

export default RichTextWidget;



// WEBPACK FOOTER //
// ./src/components/Form/Widgets/RichTextWidget/index.js